var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M41 10H25v28h16a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25 15.001h14V17H25zM25 19h14v2H25zm0 4.001h14v2H25zm0 4h14V29H25zM25 31h14v2.001H25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D47A1",
    d: "M27 42 6 38V10l21-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.167 31.012H18.45l-1.802-8.988a9.328 9.328 0 0 1-.174-1.576h-.032c-.043.637-.11 1.162-.197 1.576l-1.85 8.988h-2.827l-2.86-14.014h2.675l1.536 9.328c.062.404.111.938.143 1.607h.042a9.962 9.962 0 0 1 .223-1.645l1.97-9.291h2.622l1.785 9.404c.062.348.119.846.17 1.511h.031c.02-.515.073-1.035.16-1.563l1.503-9.352h2.468l-2.869 14.015z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.88e33a7c.svg";
export { ForwardRef as ReactComponent };